import { render } from "./ShimmerCategories.vue?vue&type=template&id=e97286ac"
import script from "./ShimmerCategories.vue?vue&type=script&lang=js"
export * from "./ShimmerCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__